import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { message } from "antd";
import rtkRequestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import Message from "../../components/Message/Message";
import { linksCreateRoute, linksDeleteRoute } from "../../lib/routes/links";
import { LinkDto } from "../../lib/interfaces";
import { LoadingStatusCode } from "../../lib/types";

interface InitialState {
  createManagerResponse?: LinkDto;
  createManagerLoading: LoadingStatusCode;
  deleteManagerLoading: LoadingStatusCode;
}

const initialState: InitialState = {
  createManagerLoading: rtkRequestStatusCodes.idle,
  deleteManagerLoading: rtkRequestStatusCodes.idle,
};
const createManager = createAsyncThunk<
  LinkDto,
  { params: { linkTypeAlias: string }; dataPost: Partial<LinkDto> }
>("links/createManager", async ({ params, dataPost }) => {
  try {
    const response = axios.post(linksCreateRoute(params), dataPost);
    const { data } = await response;
    message.success("Менеджер успешно прикреплен к оператору");
    return data;
  } catch (e) {
    message.destroy();
    Message("Ошибка добавления менеджера", e);
  }
});

const deleteManager = createAsyncThunk<
  Promise<any>,
  { linkTypeAlias: string; fromId: number; toId: number }
>("links/deleteManager", async (params) => {
  try {
    const response = axios.delete(linksDeleteRoute(params));
    const { data } = await response;
    message.success("Менеджер успешно отвязан");
    return data;
  } catch (e) {
    message.destroy();
    Message("Произошла ошибка. Пожалуйста, повторите попытку позднее", e);
  }
});

export const slice = createSlice({
  name: "links",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createManager.fulfilled, (state, action) => {
        state.createManagerResponse = action.payload;
        state.createManagerLoading = rtkRequestStatusCodes.fulfilled;
      })
      .addCase(createManager.pending, (state) => {
        state.createManagerLoading = rtkRequestStatusCodes.pending;
      })
      .addCase(createManager.rejected, (state) => {
        state.createManagerLoading = rtkRequestStatusCodes.rejected;
      })
      .addCase(deleteManager.fulfilled, (state) => {
        state.deleteManagerLoading = rtkRequestStatusCodes.fulfilled;
      })
      .addCase(deleteManager.pending, (state) => {
        state.deleteManagerLoading = rtkRequestStatusCodes.pending;
      })
      .addCase(deleteManager.rejected, (state) => {
        state.deleteManagerLoading = rtkRequestStatusCodes.rejected;
      });
  },
});

const { reducer } = slice;

export { createManager, deleteManager };

export default reducer;
